import React from "react";
import Layout from "../layout/default";
import { Block } from "../components";
import StaffAbsencesCalendar from "../components/StaffAbsences/StaffAbsencesCalendar";

export default function StaffAbsencesCalendarPage() {
  return (
    <Layout title="Staff Absences Calendar" content="container">
      <Block>
        <StaffAbsencesCalendar />
      </Block>
    </Layout>
  );
}
